import { DetailsRimState, RimTotal, RimTotalItemsTab } from './types';
import { RimListResponse, RimTotal as RimTotalResponse } from '../../../business/models/dto/rim/rim-list.response.dto';

import { BusinessResult, BusinessPolicy } from '../../../business/models/policy-business.model';
import { RimResponse } from '../../../business/models/dto/rim/rim.response.dto';
import { RimViews } from './model';

export function mapRimResponseToState(state: DetailsRimState, rimResponse: RimResponse): DetailsRimState {
  const result: DetailsRimState = {
    ...state,
    rimHeaderId: rimResponse.rimHeaderId,
    valueAndCause: {
      valueBuildingBeforeAccident: (rimResponse.valueBuildingBeforeAccident) ? rimResponse.valueBuildingBeforeAccident.toString() : '',
      valueContentBeforeAccident: (rimResponse.valueContentBeforeAccident) ? rimResponse.valueContentBeforeAccident.toString() : '',
      damageCauseRemark: rimResponse.damageCauseRemark,
      cloneInsuredAmountBuilding: (rimResponse.cloneInsuredAmountBuilding) ? rimResponse.cloneInsuredAmountBuilding.toString() : '',
      cloneInsuredAmountContent: (rimResponse.cloneInsuredAmountContent) ? rimResponse.cloneInsuredAmountContent.toString() : '',
      cloned: rimResponse.cloned
    },
    vatAndPayment: {
      deductibleVatPercentage: rimResponse.deductibleVatPercentage,
      vat6ToBeJustifiedAmount: rimResponse.vat6ToBeJustifiedAmount,
      vat21ToBeJustifiedAmount: rimResponse.vat21ToBeJustifiedAmount,
      paidByBankTransfer: rimResponse.paidByBankTransfer,
      bban: rimResponse.bban,
      bicCode: rimResponse.bicCode,
      iban: rimResponse.iban
    },
    counterExpertise: {
      nameTP: rimResponse.nameTP,
      nameTPCompany: rimResponse.nameTPCompany,
      referteTP: rimResponse.referteTP,
      realValue: rimResponse.realValue != null ? rimResponse.realValue === 0 ? '' : rimResponse.realValue.toString() : '',
      counterExpertSignedName: rimResponse.counterExpertSignedName,
      comment: rimResponse.comment
    },
    remark: {
      remark: rimResponse.remark,
      remarkSelected: rimResponse.remarkSelected
    },
    communication: {
      sendEmailToPolicyHolder: rimResponse.sendEmailToPolicyHolder,
      emailPolicyHolder: rimResponse.emailPolicyHolder,
      sendEmailToCounterExpert: rimResponse.sendEmailToCounterExpert,
      emailCounterExpert: rimResponse.emailCounterExpert,
      sendEmailToPersonalExpert: rimResponse.sendEmailToPersonalExpert,
      emailPersonalExpert: rimResponse.emailPersonalExpert,
      sendEmailToOther: rimResponse.sendEmailToOther,
      emailOther: rimResponse.emailOther,
      sendDaccaEmailToPolicyHolder: rimResponse.sendDaccaEmailToPolicyHolder,
      sendDaccaEmailToCounterExpert: rimResponse.sendDaccaEmailToCounterExpert,
      sendDaccaEmailToPersonalExpert: rimResponse.sendDaccaEmailToPersonalExpert,
      sendDaccaEmailToOther: rimResponse.sendDaccaEmailToOther,
      sent: rimResponse.sent
    },
    signing: {
      personalExpertSignedName: rimResponse.personalExpertSignedName,
      signatureCounterExpert: rimResponse.signatureCounterExpert,
      signatureExpertOrInspector: rimResponse.signatureExpertOrInspector,
      signaturePersonalExpert: rimResponse.signaturePersonalExpert,
      signaturePolicyHolder: rimResponse.signaturePolicyHolder,
      signedOn: rimResponse.signedOn,
      cloneSuffererName: rimResponse.cloneSuffererName,
      cloneSuffererLocation: rimResponse.cloneSuffererLocation,
      reflectionTime: rimResponse.reflectionTime === undefined ? true : rimResponse.reflectionTime
    },
    locked: rimResponse.locked,
    rimLines: rimResponse.rimLines,
    createdByName: rimResponse.createdByName,
    createdByCompany: rimResponse.createdByCompany,
    createdByCompanyDibCode: rimResponse.createdByCompanyDibCode,
    createdByFirstName: rimResponse.createdByFirstName,
    createdByLastName: rimResponse.createdByLastName,
    approved: rimResponse.approved
  };

  return result;
}


export function mapRimTotalsResponseToRim(state: DetailsRimState, response: RimListResponse): DetailsRimState {
  const newRimTotalItemsTab: RimTotalItemsTab = {};
  const rimTotalsResponse = response.rimsTotal as RimTotalResponse[];

  const newRimTotalItems = rimTotalsResponse.map(item => {
    const mappedItem: RimTotal = {
      rimHeaderId: item.rimHeaderId,
      totalAmount: item.totalAmount,
      locked: item.locked,
      rimData: item.rimData
    };

    newRimTotalItemsTab[`${item.rimHeaderId}`] = {};
    newRimTotalItemsTab[`${item.rimHeaderId}`][RimViews.rimLines] = { isSaved: item.tabLinesIsSaved, isDirty: false };
    newRimTotalItemsTab[`${item.rimHeaderId}`][RimViews.valueAndCause] = { isSaved: item.tabValueAndCauseIsSaved, isDirty: false };
    newRimTotalItemsTab[`${item.rimHeaderId}`][RimViews.vatAndPayment] = { isSaved: item.tabVatAndPaymentIsSaved, isDirty: false };
    newRimTotalItemsTab[`${item.rimHeaderId}`][RimViews.counterExpertise] = { isSaved: item.tabCounterExpertiseIsSaved, isDirty: false };
    newRimTotalItemsTab[`${item.rimHeaderId}`][RimViews.remark] = { isSaved: item.tabRemarkIsSaved, isDirty: false };
    newRimTotalItemsTab[`${item.rimHeaderId}`][RimViews.communication] = { isSaved: item.tabCommunicationIsSaved, isDirty: false };
    newRimTotalItemsTab[`${item.rimHeaderId}`][RimViews.signing] = { isSaved: item.tabSigningIsSaved, isDirty: false };

    return mappedItem;
  });

  return {
    ...state, ...response, rimsTotal: newRimTotalItems, rimTotalItemsTabs: newRimTotalItemsTab
  };
}
export function mapPolicyBusinessToRim(state: DetailsRimState, policyResult: BusinessResult): DetailsRimState {
  const policy = policyResult.data as BusinessPolicy;

  let stateValidationErrors = state.validations;

  const validErrors = policyResult.validations;
  validErrors.filter(el => el.hasError === false).forEach(elem => {
      stateValidationErrors = stateValidationErrors.filter(item => item.businessValidationType !== elem.businessValidationType);
  });

  stateValidationErrors.push(...policyResult.validations);

  const newRimTotals = state.rimsTotal.map(x => {
    if (x.rimHeaderId === policy.Rim.id) {
      x.rimData.rimStatusTC = policy.Rim.rimStatusTC;
    }
    return x;
  });

  return {
    ...state,
    rimLinesAmountTotal: policy.Rim.rimLinesAmountTotal,
    rimLinesAmount80Total: policy.Rim.rimLinesAmount80Total,
    rimLines: [...policy.Rim.rimLines],
    currentRimLine: policy.Rim.currentRimLine,
    vatAndPayment: {
      bban: policy.Rim.bban,
      bicCode: policy.Rim.bicCode,
      deductibleVatPercentage: policy.Rim.deductibleVatPercentage,
      iban: policy.Rim.iban,
      paidByBankTransfer: policy.Rim.paidByBankTransfer,
      vat6ToBeJustifiedAmount: policy.Rim.vat6ToBeJustifiedAmount,
      vat21ToBeJustifiedAmount: policy.Rim.vat21ToBeJustifiedAmount
    },
    rimsTotal: newRimTotals,
    validations: stateValidationErrors
  };
}
